export default "/static/dashboard/build/app/img/v2/d167c2967170139f13011af2d12a991b.png";